import { render, staticRenderFns } from "./workerRecommend.vue?vue&type=template&id=0f76eb1c&scoped=true"
import script from "./workerRecommend.vue?vue&type=script&lang=js"
export * from "./workerRecommend.vue?vue&type=script&lang=js"
import style0 from "./workerRecommend.vue?vue&type=style&index=0&id=0f76eb1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f76eb1c",
  null
  
)

export default component.exports